module.exports = __webpack_public_path__ + "img/3.f6013f78.jpg";